import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, Hand, Droplets, Heart, Leaf, ArrowRight } from 'lucide-react';
import './Services.css';
import './SpaExperiences.css';

function SpaExperiences() {
  return (
    <>
      <section className="page-hero">
        <div className="page-hero__bg">
          <img src="/images/corgi-bath.jpg" alt="Spa experience" />
          <div className="page-hero__overlay" />
        </div>
        <div className="page-hero__content container">
          <span className="section-label" style={{ color: 'var(--color-accent-light)' }}>Luxury Add-Ons</span>
          <h1 className="page-hero__title">Spa Experiences &amp; Little Treats</h1>
          <p className="page-hero__subtitle">
            The perfect addition to your dog&rsquo;s grooming regime for added luxury and wellness.
          </p>
        </div>
      </section>

      <section className="services-intro section">
        <div className="container">
          <div className="services-intro__content">
            <p>
              In addition to our standard grooming services we offer a range of health and wellness
              treatments to enhance the spa experience and complement the standard treatments
              ensuring your dog feels amazing!
            </p>
            <p>
              Choose from our range of spa treatments for specific coat types, or scroll down to
              our little treats such as a pawidcure or signature facial.
            </p>
            <p>
              We also offer Emmipet Ultrasonic teeth cleaning, a non-invasive, silent treatment
              designed to remove plaque and kill bacteria. Teeth cleaning should be a part of your
              dog&rsquo;s regular health and wellbeing schedule and we would recommend adding this
              service to your pet&rsquo;s routine grooming schedule.
            </p>
          </div>
        </div>
      </section>

      <section className="spa section" style={{ paddingTop: 0 }}>
        <div className="container">
          <div className="text-center" style={{ marginBottom: 48 }}>
            <span className="section-label">Coat Treatments</span>
            <h2 className="section-title">Spa Treatments</h2>
          </div>

          <div className="spa__grid">
            <div className="spa-card">
              <div className="spa-card__icon">
                <Leaf size={32} />
              </div>
              <h3 className="spa-card__title">Shed Control</h3>
              <p className="spa-card__subtitle">Optimal Shed Control</p>
              <p className="spa-card__text">
                Hemp oils and natural clays combine in this treatment, along with rosemary and
                eucalyptus cleansers, to provide deep conditioning and aid the removal of dead
                hair. Natural minerals condition the skin and coat which can help reduce excessive
                shedding in double coated breeds.
              </p>
            </div>

            <div className="spa-card">
              <div className="spa-card__icon">
                <Sparkles size={32} />
              </div>
              <h3 className="spa-card__title">Dotty About Doodles</h3>
              <p className="spa-card__subtitle">Perfect for Poo&rsquo;s and Doo&rsquo;s</p>
              <p className="spa-card__text">
                Our most popular treatment for cockapoos, doodles and poodle crosses prone to
                knots and tangles. Gentle cleansing agents remove dirt without stripping any
                moisture from the coat. Argan oil conditioning treatments leave hair revitalised,
                adding texture, body and shine. This treatment helps tame those tangles and aids
                maintenance for the perfect shaggy chic look!
              </p>
            </div>

            <div className="spa-card spa-card--wide">
              <div className="spa-card__icon">
                <Heart size={32} />
              </div>
              <h3 className="spa-card__title">Itch Control</h3>
              <p className="spa-card__subtitle">Calm and Soothe</p>
              <p className="spa-card__text">
                Nourish, strengthen and encourage healthy cell regeneration with a therapeutic mud
                treatment. As the mud mask detoxifies the skin, dead skin cells are exfoliated away
                providing nourishing and soothing skin relief. Loaded with antioxidants, calming
                kaolin and healing quartz, this mask is combined with Rosemary and Wild Mint
                shampoo, known for astringent properties, followed by a sensitive yet soothing conditioner.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="treats section" style={{ background: 'var(--color-cream)' }}>
        <div className="container">
          <div className="text-center" style={{ marginBottom: 48 }}>
            <span className="section-label">Add Something Special</span>
            <h2 className="section-title">Little Treats</h2>
            <p className="section-subtitle">
              An extra little something. All of our Little Treats can be used in conjunction
              with any grooming service.
            </p>
          </div>

          <div className="spa__grid">
            <div className="spa-card">
              <div className="spa-card__icon">
                <Hand size={32} />
              </div>
              <h3 className="spa-card__title">Nose and Toes</h3>
              <p className="spa-card__text">
                Helps soothe paws damaged by gravel, pavements, snow, or those that get itchy feet
                in the summer months due to pollen and other irritants. Gentle paw soak and massage,
                nail trimming and filing along with a nourishing hemp paw butter to protect precious
                pads. A luxurious Vitamin E and Lime Oil nose lotion helps to heal and moisturise
                to keep the snoot ready for a boop!
              </p>
            </div>

            <div className="spa-card">
              <div className="spa-card__icon">
                <Droplets size={32} />
              </div>
              <h3 className="spa-card__title">Signature Facial</h3>
              <p className="spa-card__text">
                A hydrating and soothing facial treatment to cleanse and balance. Pooches with
                facial folds or deep wrinkles need a regular skin cleansing routine. Wrinkles hold
                an accumulation of food, mucus, dry tears and debris that can lead to skin
                infections and harbour bad odours.
              </p>
            </div>

            <div className="spa-card spa-card--wide">
              <div className="spa-card__icon">
                <Sparkles size={32} />
              </div>
              <h3 className="spa-card__title">Moisture Lock</h3>
              <p className="spa-card__text">
                A deep conditioning treatment containing botanical extracts is massaged into your
                dog&rsquo;s coat, followed by a warm towel wrap. Perfect for dry, dull or damaged
                coats, or those in a longer style to protect their luscious locks. Hydrates damaged
                coats and protects from the elements to reduce breakage.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="page-cta">
        <div className="container">
          <div className="page-cta__inner">
            <div className="page-cta__content">
              <h2>Treat Your Pet to a Spa Day</h2>
              <p>Contact us to add spa treatments to your next grooming session.</p>
            </div>
            <div className="page-cta__actions">
              <Link to="/contact" className="btn btn-accent">
                Book Now <ArrowRight size={16} />
              </Link>
              <a href="tel:07904813567" className="btn btn-outline" style={{ borderColor: 'var(--color-white)', color: 'var(--color-white)' }}>
                Call Us
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default SpaExperiences;
